import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { passwordRegex, passwordError, API } from "../../utils/helper";
import "../../css/Wireframe.css";

export default class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {}

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.currentPassword || !s.currentPassword.trim()) {
      errors.currentPassword = "Current password is required";
      valid = false;
    }

    if (!s.newPassword || !s.newPassword.trim()) {
      errors.newPassword = "New password is required";
      valid = false;
    } else if (!passwordRegex.test(s.newPassword)) {
      errors.newPassword = passwordError;
      valid = false;
    }

    if (!s.confirmPassword || !s.confirmPassword.trim()) {
      errors.confirmPassword = "Please confirm your new password";
      valid = false;
    } else if (s.newPassword !== s.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
        loading: false,
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    const username = sessionStorage.getItem("username");
    axios
      .post(
        API + "/security/changepassword",
        {
          currentPassword: this.state.currentPassword,
          password: this.state.newPassword,
          username: username,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Password changed successfully.",
            toastColor: "success",
            loading: false,
          });
          this.setState({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            errors: {},
          });
          window.history.back();
        } else {
          this.setState({
            msg: response.data.message || "Failed to change password.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to change password. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Change Password" />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col items-center justify-center">
            <form
              className="flex flex-col items-center w-full max-w-md mt-8 gap-4"
              autoComplete="off"
              onSubmit={this.handleSubmit}
            >
              <div className="input-group mt-2 w-full">
                <label className="input-group-text">Current Password</label>
                <input
                  type="password"
                  name="currentPassword"
                  className={`form-control ${
                    s.errors.currentPassword ? " !border-red-500" : ""
                  }`}
                  value={s.currentPassword}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.currentPassword && (
                  <span className="input-group-error">
                    {s.errors.currentPassword}
                  </span>
                )}
              </div>
              <div className="input-group mt-2 w-full">
                <label className="input-group-text">New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  className={`form-control ${
                    s.errors.newPassword ? " !border-red-500" : ""
                  }`}
                  value={s.newPassword}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.newPassword && (
                  <span className="input-group-error">
                    {s.errors.newPassword}
                  </span>
                )}
              </div>
              <div className="input-group mt-2 w-full">
                <label className="input-group-text">Confirm New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  className={`form-control ${
                    s.errors.confirmPassword ? " !border-red-500" : ""
                  }`}
                  value={s.confirmPassword}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.confirmPassword && (
                  <span className="input-group-error">
                    {s.errors.confirmPassword}
                  </span>
                )}
              </div>
              <div className="flex justify-center gap-8 mt-4">
                {s.valid && (
                  <button type="submit" className="btn btn-success">
                    Change Password
                  </button>
                )}
              </div>
            </form>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
